import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Grid,
  GridItem,
  Image,
  Divider,
  Flex,
  Icon,
  Center,
} from "@chakra-ui/react";
import { BackwardIcon, DownIcon } from "../assets/Icons";
import MapImage from "../assets/Basemap image.png";
import CuLogo from "../assets/cu-logo-head.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getClientTrace, getTcDetailFoTrace } from "./api";
import GoogleMap from "./GoogleMap";
import moment from "moment";
import GccLogo from "../../../assets/images/resources/cu-logo-tree-foot.png";

function DetailPageV3({ traceVersion }) {
  const [details, setDetails] = useState([]);
  const { id, category } = useParams();
  const [categoryDetails, setCategoryDetails] = useState();
  const [markers, setMarkers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };
  const location = useLocation();
  const { company } = location.state || {};
  console.log(company);

  const getTraceDetails = async (id, traceVersion) => {
    setIsLoading(true);
    try {
      const res = await getClientTrace(id, traceVersion);
      if (res?.status === "success") {
        setIsLoading(false);
        setDetails(res?.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getTraceDetails(id, traceVersion);
  }, [traceVersion, id]);

  useEffect(() => {
    const uniqueCategory = [];
    details[category]?.map((element) => {
      const organizationName = element?.tc_seller?.name;
      const date = element?.approvedAt;
      const address = element?.tc_seller?.address?.raw_address;
      const tcNumber = element?.tcNumber;
      const inputProduct = element?.products
        ?.map((product) =>
          product?.inputs?.map((input) => input?.productClassification?.name)
        )
        ?.flat()
        .filter((item, index, arr) => arr.indexOf(item) === index);

      const outputProduct = element?.products
        ?.map((el) => {
          return el?.productId?.product_productClassification?.name;
        })
        ?.filter((item, index, arr) => arr.indexOf(item) === index);
      const certifiedWeight = element?.totalCertifiedWeight;

      uniqueCategory?.push({
        organizationName: organizationName,
        date: date,
        address: address,
        inputProduct: inputProduct,
        outputProduct: outputProduct,
        certifiedWeight: certifiedWeight,
        tcNumber: tcNumber,
      });

      setCategoryDetails(uniqueCategory);
    });
  }, [details]);

  const formatMarkers = (data) => {
    const markers = [];
    for (const process in data) {
      for (const obj of data[process]) {
        if (process !== "Farmers" && obj?.tc_companyUnit?.address?.location) {
          const unit = obj?.tc_companyUnit;
          const name = `${unit?.address?.location?.raw_address}, ${unit?.address?.location?.state}`;
          const position = {
            lat: unit.address.location.coordinates[0],
            lng: unit.address.location.coordinates[1],
          };
          if (unit.address.location.coordinates?.[0]) {
            markers.push({ name, position });
          }
        }
      }
    }
    setMarkers(markers);
  };

  useEffect(() => {
    if (details) {
      formatMarkers(details);
    }
  }, [details]);

  return (
    <Box bg="white" maxW="480px">
      {/* header */}
      <Box
        bg="#EFEFF4"
        h="200px"
        borderBottomRadius={"15px"}
        px={"2rem"}
        mb="3rem"
      >
        <Flex
          justifyContent={"space-between"}
          alignItems={"center"}
          // py={"1rem"}
        >
          <Box>
            <BackwardIcon onClick={handleGoBack} />
          </Box>
          <Box>
            <Image boxSize="75px" src={GccLogo} alt="Control Union" />
          </Box>
        </Flex>
        <Box>
          <Text fontSize="16px" fontWeight="700" w="100px">
            Farm to fork Certified Processes{" "}
          </Text>
          <Text fontSize="14px" m={0}>
            TC Number: {id}
          </Text>
          <Text fontSize="34px" fontWeight={"700"}>
            {category === "Farmer" ? "Suppliers" : category}
          </Text>
        </Box>
      </Box>
      <Divider
        bg={"#AFAFAF"}
        width={"100%"}
        height={"1px"}
        my={"2rem"}
        borderRadius={"50px"}
      />
      {/* body content goes */}
      {markers?.length > 0 && (
        <>
          <Box p="1rem" mb={"2rem"}>
            <Text fontSize="16px" fontWeight={"700"} mt="1rem">
              Units across Geography
            </Text>
            <Box
              position="relative"
              overflow="hidden"
              w="100%"
              pt="56.25%"
              marginTop={"1rem"}
            >
              <Box
                position="absolute"
                top={0}
                left={0}
                w="100%"
                h="100%"
                borderRadius="50px"
              >
                <GoogleMap markers={markers} />
              </Box>
            </Box>
          </Box>
        </>
      )}
      {categoryDetails?.map((el) => {
        return (
          <>
            <Box
              bg="rgba(156, 232, 179, 0.4);"
              p="1rem"
              borderRadius="10px"
              mt="1rem"
              mx="1rem"
              mb={"2rem"}
            >
              <Grid templateColumns={"1.5fr 0.5fr"}>
                <GridItem>
                  <Text fontSize="12px">TC Number: {el?.tcNumber}</Text>
                </GridItem>
                <GridItem>
                  <Text fontSize="11px">
                    Date: {moment(el?.date).format("l")}
                  </Text>
                </GridItem>
              </Grid>
              <Text color="#464C64" fontSize="14px" fontWeight={"700"} m={0}>
                {el?.organizationName}
              </Text>
              <Text fontSize="10px" margin={0} w="300px">
                {el?.address}
              </Text>
              <Grid templateColumns={"1fr 1fr"}>
                <GridItem>
                  <Text fontSize="11px" color="#464C64">
                    Input Product:
                    {el?.inputProduct?.map((input) => {
                      return <>{input}</>;
                    })}
                  </Text>
                  <Text fontSize="11px" color="#464C64">
                    Output Product:
                    {el?.outputProduct?.map((output) => {
                      return <>{output}</>;
                    })}
                  </Text>
                </GridItem>
                <GridItem>
                  <Text fontSize="11px" color="#464C64">
                    Certified Weight: {el?.certifiedWeight}
                    {"Kg"}
                  </Text>
                  {/* <Text fontSize="11px" color="#464C64">
                    Output Quantity: 20040
                    </Text> */}
                </GridItem>
              </Grid>
            </Box>
          </>
        );
      })}
      {company?.data?.tc_procurements?.length > 0 && (
        <Box
          bg="rgba(156, 232, 179, 0.4);"
          p="1rem"
          borderRadius="10px"
          mt="1rem"
          mx="1rem"
          mb={"2rem"}
        >
          <Text fontSize="13px" fontWeight="700" m={0}>
            {"Suppliers"}
          </Text>
          {company?.data?.tc_procurements?.map((tc_proc) => (
            <Box borderBottom="0.1px solid  #464C64">
              <Text color="#464C64" fontSize="14px" m={0}>
                {tc_proc?.procurement_supplier?.name
                  ? tc_proc?.procurement_supplier?.name
                  : `${tc_proc?.procurement_supplier?.firstName} ${tc_proc?.procurement_supplier?.lastName}`}
              </Text>
              <Text color="#464C64" fontSize="11px" m={0}>
                {tc_proc?.supplierType} {""}{" "}
                {tc_proc?.procurement_supplier?.type
                  ? `(${tc_proc?.procurement_supplier?.type})`
                  : ""}
              </Text>
              <Flex>
                <Text fontSize="11px" color="#464C64">
                  Total Certified Weight:{" "}
                  {tc_proc?.stockQuantity?.certifiedWeight || "N/A"}
                </Text>
                <Text fontSize="11px" color="#464C64">
                  Total Gross Quantity: {tc_proc?.stockQuantity?.grossWeight}
                </Text>
                <Text fontSize="11px" color="#464C64">
                  Total Net Quantity: {tc_proc?.stockQuantity?.netWeight}
                </Text>
                <Text fontSize="11px" color="#464C64">
                  Product: {tc_proc?.product_productClassification?.name}-
                  {tc_proc?.type}
                </Text>
              </Flex>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default DetailPageV3;
